import React from "react";
import * as S from "./styles";
export var Loader = function Loader(_ref) {
  var fullScreen = _ref.fullScreen;
  return React.createElement(S.Wrapper, {
    fullScreen: !!fullScreen
  }, React.createElement(S.Items, null, React.createElement("span", null), React.createElement("span", null), React.createElement("span", null)));
};